import { FC, useEffect, useState } from "react";
import { Container, Box, Grid, Link } from "@material-ui/core";
import { Link as RouterLink } from "react-router-dom";
import { ReviewsCard, StatCard } from "./Cards";
import { DashboardData } from "./Types";
import ChartCard from "src/components/ui-components/ChartCard";
import { GetDashboardStatistics } from "./ConnectionService";
import CustomSkeleton from "src/components/skeleton/Skeleton";
import { androidReviews, iOSReviews } from "./DummyData";
import { Helmet } from "react-helmet-async";

const defaultDashboardData: DashboardData = {
  statCards: [],
  chartData: []
};

const AdminDashboard: FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dashboardData, setDashboardData] = useState<DashboardData>(defaultDashboardData);

  const getDashboardData = async () => {
    setIsLoading(true);
    var res: DashboardData = await GetDashboardStatistics();
    if (res) {
      setDashboardData({
        statCards: res.statCards || [],
        chartData: res.chartData || []
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getDashboardData();
  }, []);

  return (
    <>
      <Helmet>
          <title>Dashboard</title>
      </Helmet>
      <Box sx={{ minHeight: '92vh' }}>
        <Container maxWidth={false}>
          <Grid
            alignItems='center'
            sx={{ my: 2, marginBottom: '2%' }}
            container
            justifyContent='space-between'
          >
            <Grid item>
              <Link
                color='textPrimary'
                variant='h4'
                component={RouterLink}
                to=''
                sx={{ marginBottom: '2%', fontWeight: 'bold' }}
              >
                Dashboard
              </Link>
            </Grid>
            <Grid item />
          </Grid>
          {isLoading && (
            <Grid container spacing={2}>
              <CustomSkeleton skeletonType="PageLoader"/>
            </Grid>
          )}
          {!isLoading && dashboardData && (
            <Grid container spacing={2} marginBottom='2%'>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, width: '100%', paddingLeft: '1%' }}>
                  {dashboardData?.statCards?.map((card, idx) => {
                    const totalCards = dashboardData.statCards.length;
                    const columns = totalCards === 4 ? 3 : 4;

                    return (
                      <Grid item key={`${card.cardTitle}-${idx}`} xs={12} sm={12} md={columns} lg={columns} xl={columns}>
                        <StatCard 
                          cardTitle={card.cardTitle} 
                          icon={card.icon} 
                          statCount={card.statCount} 
                          backgroundColor={card.backgroundColor} 
                          cardBorderColor={card.cardBorderColor} 
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, width: '100%', paddingLeft: '1%' }}>
                  {dashboardData?.chartData?.map((chart, idx) => (
                    <Grid item key={`${chart.title}-${idx}`} xs={12} sm={12} md={12} lg={6} xl={6}>
                      <ChartCard
                        title={chart.title}
                        chartData={chart.chartData}
                        backgroundColor={chart.backgroundColor}
                        borderColor={chart.borderColor}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <ReviewsCard title='Android Reviews' reviews={androidReviews} />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <ReviewsCard title='iOS Reviews' reviews={iOSReviews} />
              </Grid>
            </Grid>
          )}
        </Container>
      </Box>
    </>
  );
};

export default AdminDashboard;
